import { AccountListItemData, v2 } from '@deqo/api-bindings';
import { useQuery } from '@tanstack/react-query';

// Optional filters supported by me.accounts.list. Archived accounts are always
// excluded server-side; these narrow the list further:
//  - active: drop read-only (expired/cancelled) accounts
//  - member: drop accounts the user is only a guest of (member or greater)
//  - mcp:    drop accounts where MCP has been switched off (restrictMcp)
export interface AccountListParams {
    active?: boolean;
    member?: boolean;
    mcp?: boolean;
}

export const useAccountListQuery = (params: AccountListParams = {}) =>
    useQuery({
        queryKey: ['me.accounts.list', params],
        queryFn: async (): Promise<AccountListItemData[]> => {
            const call = v2.me.accounts.list();
            const search = new URLSearchParams();
            if (params.active) search.set('active', 'true');
            if (params.member) search.set('member', 'true');
            if (params.mcp) search.set('mcp', 'true');
            const qs = search.toString();
            const res = await fetch(`/api/v2${call.path}${qs ? `?${qs}` : ''}`, { headers: { accept: 'application/json' } });
            if (!res.ok) throw new Error(`Status ${res.status}`);
            const data = await res.json();
            return call.transform ? call.transform(data) ?? data : data;
        },
    });
